// 用于接口的类型校验
export interface IChatRecordParams {
  classroomId: number;
  size?: number;
  page?: number;
  includePrivateChat?: boolean; // 是否返回私聊内容
}

export enum Role {
  TEACHER = 1,
  ASSISTANT,
  STUDENT,
  OBSERVER,
  ADMIN,
}
export enum ContentType {
  TEXT = 1,
  IMAGE,
}
export interface Chat {
  userName: string;
  uid: string;
  role: Role;
  nickName: string;
  realName?: string | null;
  sentTime: number;
  id?: number;
  content: Array<{
    text: string;
    type: ContentType;
  }>
  option?: string;
  // 私聊相关字段
  toUid?: string;
  toRole?: Role;
  toNickName?:string;
  toUserName?: string;
  toRealName?: string;
}
export interface IChatRecordRes {
  total: number;
  chatList: Array<Chat>;
}

export enum PointType {
  POINT = 1,
  MARK,
  QUIZ, // 答题卡
  GAME, // 互动课件
  PRACTICE_UNION, // 练习题（包含答题卡和互动课件）
  CHPATER = 9, // AI知识点
}

export enum RemarkType {
  FOCUS = 1,
  DIFFICUTE,
}
export interface IAddKnoPointParams {
  note?: string;
  type: PointType;
  remarkType?: RemarkType;
  startTime: number;
  endTime: number;
  classroomId: number;
  quizId?: string;
  screenshotUrl?: string;
}

export interface IAddKnoPointRes {
  noteId: number;
}

export interface ISignedUrlParams {
  type: number;
  path: string;
  contentType?: 'image/jpeg';
}

export interface ISignedUrlRes {
  accessKeyId: string;
  bucketName: string;
  cdnUrl: string;
  objectName: string;
  signedUrl: string;
}

export interface INoteListParams {
  classroomId: number;
}

export interface Note {
  noteId: number | null;
  note: string;
  startTime: number;
  endTime: number;
  type: PointType;
  remarkType?: RemarkType;
  screenshotUrl?: string;
  publishStatus?: number;
}

export interface IDelMarkParams {
  noteId: number;
}

export interface IGetKnoPointShareUrlParams {
  noteId: number;
  isLimit: 0 | 1;
}
// export interface Quiz {

// }
export enum PracticeType {
  XDF = 1,
  EXTERNAL,
}
export interface Practice {
  id: string;
  startTime: number;
  endTime?: number;
  title: string;
  type: PracticeType;
  quizSeq?: number;
}
export interface INoteListRes {
  total: number;
  noteList?: Array<Note>;
  quizList?: Array<any>;
  externalQuestionList?: Array<any>;
  practiceUnion?: Array<Practice>;
}
export interface IsTourRes {
  videoShareType: number;
  videoUrl: Array<string>;
  name: string;
}

export interface IsTourParams {
  classroomId: string | number;
}

export interface ShareInfoRes {
  startTime: number;
  endTime: number;
  isLimited: number;
}

export interface ShareInfoParams {
  shareCode: string;
}
// IsTourRes

export type ReplayConfigParams = {
  roleId?: number;
  classroomId: number | string;
};

export type KnowledgeConfigType = {
  hasPublished: boolean;
  isShowAIKnowledgeButton: boolean;
  teacherAiKnowledgeSwitch: boolean;
};

export type ReplayConfigRes = {
  isValid: boolean; // 回放是否有效，true有效，false无效（表示过期）
  isAward: boolean; // 是否已奖励，true是，false否
  threshold: number; // 观看回放大于等于此值时奖励星星，单位s，-1(小于0)表示没有奖励规则
  starNum: number; // 奖励星星数
  aiNotePageConfig?: RecapConfig;
  needReportPlayBack?: boolean;
  knowledgeConfig: KnowledgeConfigType;
};

type RecapConfig = {
  pageEnabled: boolean; // 是否展示AI知识点功能
  userEnabled: boolean; // 用户是否启用AI知识点功能
  metaStatus?: MetaStatus; // 任务状态 0历史没有触发任务 1任务处理中 2任务成功 3任务失败
  dataUrl?: string; // 数据文件地址
  subtitleUrl?: string; // 字幕文件地址
  userToken?: string; // AI知识点页面专用token
  transUri?: string; // v2版本获取数据接口
};

export enum MetaStatus {
  NODATA, // 默认从0开始
  PROCESSING,
  SUCCESS,
  FAILED,
}

export type RecapToggleParams = {
  classroomId?: number;
  cleanNoteList?: boolean;
  enable: boolean;
  type?: number;
};

export type RecapFeedbackParams = {
  // SummaryLabResults=章节概要 DocResult=授课全文 FullTextSummaryResult=全文概要
  biz_type: 'SummaryLabResults' | 'DocResult' | 'FullTextSummaryResult',
  biz_id: string, // 反馈的原文内容，在全部内容中相对位置，方便定位使用.FullTextSummaryResult类型传"0"；TopicLabResults类型,传元素的id；DocResult类型，传元素的pi的值
  creator: string; // 反馈人信息，有邮箱就填邮箱，没有就名字或者uid
  func_type: 'AiTransInfo'; // 平台功能类型，前后端协商确定
  raw_content: string; // 反馈原文
  submit_option: {
    option_1_feedback: string; // 用户反馈内容
    option_1_score: '100' | '0'; // 好的反馈传'100',坏的反馈传'0'
  },
  uuid: string; // mediaId 资源id
};
export type RecapFeedbackRes = {
  http_code: number; // httpcode 同http协议返回的code 正确的话就是200
  err_code: number; // 错误码
  err_msg: string; // 错误描述
  comp_id: number; // 系统标识
};

export type PublishKnoPointParams = {
  classroomId: number;
  noteList: Note[];
  isPublish: boolean;
};

export type GetHighLightVideoParams = {
  cid: number;
}

export type GetHighLightVideoRes = {
  mediaId: string
  status: number | string
  inClassroom: number | string
}